import { StackLayout } from '@euler/app/components/StackLayout';
import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReactNode, memo } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

export const Section = memo(
  ({
    title,
    titleRight,
    children,
    style,
    contentContainerStyle,
  }: {
    title: string;
    titleRight?: ReactNode;
    children?: ReactNode;
    style?: StyleProp<ViewStyle>;
    contentContainerStyle?: StyleProp<ViewStyle>;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={style}
        css={`
          background-color: #fff;
          margin-bottom: ${rpx(15)}px;
          border-radius: ${rpx(15)}px;
        `}
      >
        <StackLayout
          direction="row"
          alignItems="center"
          gap={rpx(5)}
          css={`
            padding: ${rpx(10)}px ${rpx(15)}px;
            border-bottom-width: 1px;
            border-bottom-color: #eee;
          `}
        >
          <Typography.Title level={2}>{title}</Typography.Title>
          {titleRight}
        </StackLayout>
        <View
          style={contentContainerStyle}
          css={`
            padding: ${rpx(10)}px ${rpx(15)}px;
          `}
        >
          {children}
        </View>
      </View>
    );
  },
);
